import { ajax } from '@src/utils/ajax'
import { PromocodePayload, UserData } from '@src/types'

export const requestTranslations = (lang = 'ru') => ajax.get(`/translations/${lang}.json`)

export const requestUserInfo = () => ajax.get<UserData>('/current-user/')

export const requestCreateSearchBrief = params => ajax.post('/services/brief-create/', params)

export const requestPromocodeInfo = (searchValue: string) =>
  ajax.get<PromocodePayload>(`/info/api/promocode/search/${searchValue}`, {
    timeout: 30000
  })

export const requestActivatePromocode = (code: string, userId: number) =>
  ajax.post(
    `/info/api/promocode/accept`,
    { elamaId: userId, code },
    {
      timeout: 30000
    }
  )
